<template>
    <div></div>
</template>
<script>
export default {
    name: 'course-templates'
};
</script>
